import * as React from 'react'
import PropTypes from 'prop-types'
import { LinkType } from 'src/types/link'
import Section from 'src/components/Section'
import NextLink from 'src/components/NextLink'

import * as style from './style.module.css'

export default function Register({
  title,
  cta,
  subLinkTitle,
  subLinks,
}) {
  return (
    <Section withPadding>
      <h2 className={style.title}>{title}</h2>
      <NextLink
        button
        className={style.button}
        link={cta}
      />

      {subLinkTitle && (
        <p className={style.sub_link_title}>
          {subLinkTitle}
        </p>
      )}
      {subLinks && (
        <div className={style.sub_links}>
          {subLinks.map(subLink => (
            <NextLink
              className={style.sub_link}
              key={subLink.href}
              link={subLink}
            />
          ))}
        </div>
      )}
    </Section>
  )
}

Register.defaultProps = {
  title: `Register Title Goes Here`,
  cta: {
    text: `Sign Up`,
    href: '/',
  },
}

export const RegisterType = {
  title: PropTypes.string.isRequired,
  cta: LinkType.isRequired,
  subLinkTitle: PropTypes.string,
  subLinks: PropTypes.arrayOf(LinkType),
}

Register.propTypes = RegisterType
